<h4 class="card-title p-4">
  Copy App {{includingItems ? 'and Items' : ''}}
  <button type="button" class="close pull-right" aria-label="Close"
    (click)="activeCopyAppModal.dismiss(CloseReason.CLOSE)">
    <span aria-hidden="true">&times;</span>
  </button>
</h4>
<div class="card-body px-4 pt-4">
  <form name="form" #f="ngForm" novalidate>
    <div class="card-text pb-2">
      This copies the app structure (configuration and fields) {{includingItems ? 'and all' : 'but it contains no'}} items.
    </div>
    <div class="card-text pb-2">
      <div>
        <input type="radio" [value]=true class="form-check-input me-1" id="createNewCopy" name="createNewCopy"
          [(ngModel)]="createNamespace" (change)="triggerValidation()">
        <label class="form-check-label" for="createNewCopy">Create new namespace</label>
      </div>

      <div>
        <input type="radio" [value]=false class="form-check-input me-1" id="useExistingCopy" name="createNewCopy"
          (change)="triggerValidation()" [(ngModel)]="createNamespace"
          [attr.disabled]="!copyNamespaces.length? '' : null">
        <label class="form-check-label" for="useExistingCopy">Use existing namespace</label>
      </div>
    </div>

    @if (createNamespace) {
      <div class="mb-3 required">
        <label for="nameSpaceCopy"> Namespace of the copy</label>
        <input type="text" [(ngModel)]="newNamespace" name="name-new-copy" id="nameSpaceCopy"
          placeholder="Namespace"
          class="form-control" required>
        <small class="form-text text-muted">
          Give this copy a namespace name. Related or referenced apps/items copied later with the same namespace will be
          linked together in the selected target workspace.
        </small>
      </div>
    }

    <div class="mb-3 required">
      <div class="mb-2"> Where do you want the copy to be made?</div>
      @if (createNamespace) {
        <div class="input-group mb-3">
          <div class="input-group-prepend copy-app-label">
            <label for="selectedOrd"> Organization </label>
          </div>
          <div ngbDropdown id="selectedOrd">
            <button class="btn btn-outline-primary" ngbDropdownToggle id="dropdownOrgs">
              @if (this.loadingPodioOrgs) {
                loading...
              }
              @if (!this.loadingPodioOrgs && !selected_org) {
                Please select an organization
              }
              @if (selected_org && !this.loadingPodioOrgs) {
                {{selected_org.label}}
              }
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownOrgs">
              @for (org of orgs; track org) {
                <button class="dropdown-item" (click)="changeSpaces(org)">{{org.label}}</button>
              }
            </div>
          </div>
        </div>
      }

      @if (createNamespace && !this.loadingPodioOrgs && selected_org) {
        <div class="input-group mb-3 required">
          <div class="input-group-prepend copy-app-label">
            <label for="selectedSpace"> Workspace </label>
          </div>
          <div ngbDropdown id="selectedSpace">
            @if (!selected_space) {
              <button class="btn btn-outline-primary" ngbDropdownToggle>Please select a workspace</button>
            }
            @if (selected_space) {
              <button class="btn btn-outline-primary" id="dropdownSpaces"
              ngbDropdownToggle>{{selected_space.label}}</button>
            }
            <div ngbDropdownMenu aria-labelledby="dropdownSpaces">
              @for (space of spaces; track space) {
                <span
                  ngbPopover="{{'The workspace already has an app with the name ' + this.appName + '.' }}"
                  container="body"
                  triggers="mouseenter:mouseleave" placement="right"
                  [disablePopover]="!space.app_exists">
                  <button class="dropdown-item"
                    (click)="setSelectedSpace(space)"
                  [ngClass]="{'disabled' : space.app_exists}">{{space.label}}</button>
                </span>
              }
            </div>
          </div>
          @if (alreadyExistingNamespace) {
            <small class="form-text text-muted hint-existing-namespace">
              The namespace '{{alreadyExistingNamespace}}' already copies apps to the {{selected_space['label']}} workspace.
              Please consider using the 'Use existing namespace' option.
            </small>
          }
        </div>
      }

      @if (!createNamespace) {
        <div class="input-group mb-3 d-block">
          <div ngbDropdown>
            @if (!namespaceIsSelected()) {
              <button class="btn btn-outline-primary" ngbDropdownToggle>Please select a namespace for the copy</button>
            }
            @if (namespaceIsSelected()) {
              <button class="btn btn-outline-primary" id="dropDownSelectLogicalRestore"
              ngbDropdownToggle>{{copyNamespace.copy_namespace}}</button>
            }
            <div ngbDropdownMenu aria-labelledby="dropDownSelectLogicalRestore">
              @for (namespace of copyNamespaces; track namespace) {
                <span
                  ngbPopover="{{'The workspace already has an app with the name ' + this.appName + '.'}}"
                  container="body"
                  triggers="mouseenter:mouseleave" placement="right"
                  [disablePopover]="namespace.copyIsAllowed">
                  <button class="dropdown-item"
                    [ngClass]="{'disabled' : !namespace.copyIsAllowed}"
                  (click)="setExistingCopyNamespace(namespace)">{{namespace.copy_namespace}}</button>
                </span>
              }
            </div>
          </div>
          @if (!createNamespace && namespaceIsSelected()) {
            <small class="form-text text-muted">
              Namespace target:<br>
              Organization: {{copyNamespace.target_org_name}}
              <br>
                Workspace: {{copyNamespace.target_space_name}}
              <br>
                Copies using this namespace will be made in this workspace.
              </small>
            }
          </div>
        }
      </div>

      <div class="mb-3">
        Do you want to copy the app@if (includingItems) {
        and all items
        }?
        @if (!createNamespace) {
          This may overwrite changes!
        }
        <div class="form-text text-muted">
          To keep references between apps, copy related apps/items using the same namespace. If this app references other
          apps, copy the referenced apps/items with this namespace first, or copy them later and re-run this copy to update
          references.
        </div>
        <div class="text-end">
          <ng-container>
            <span
              [disablePopover]="f.form.valid && validate"
              class="d-inline-block"
              ngbPopover="{{createNamespace ? 'Enter a namespace, select organization and space' : 'Select a namespace'}}"
              placement="bottom"
              triggers="mouseenter:mouseleave">
              <button (click)="clickSubmit()"
                [disabled]="!f.form.valid || !validate"
                class="btn btn-primary me-1"
                type="button">OK
              </button>
            </span>
            <button (click)="activeCopyAppModal.close(CloseReason.CANCEL)" class="btn btn-outline-secondary"
              type="button">Cancel
            </button>
          </ng-container>
        </div>
      </div>
    </form>
  </div>
